export default "/static/image/tabbar/bg.webp"